export default __webpack_public_path__ + "static/5-ca624b391ee8f85c080fdb3ee93bb164.webp";